/**
 * Responsive sources for images served by the files API.
 *
 * A file's `contentUrl` (`/api/files/<id>/content`) answers `?w=` with the
 * smallest stored display size at least that wide, or the original when there
 * is none, so a page can always list every width and let the browser pick the
 * one its layout and screen need. Anything else — a photo shipped with the app,
 * an asset on the CDN — exists at one size only and gets no `srcset`.
 */

import { FILE_IMAGE_WIDTHS } from '../types/file';

const FILE_CONTENT_URL = /\/api\/files\/[0-9a-f-]+\/content$/i;

/** A `srcset` of every display width of a files-API image, or undefined for any other source. */
export function fileImageSrcSet(src: string): string | undefined {
  if (!FILE_CONTENT_URL.test(src)) return undefined;
  return FILE_IMAGE_WIDTHS.map((width) => `${src}?w=${width} ${width}w`).join(', ');
}
